import {Component, OnInit, Input} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {PlumberDetailsMfb} from '../../data-objects/plumber-details-mfb';

const phoneNumberRE = /^\d{10}$/;
const vbaLicenseRE = /^\d{1,6}$/;
const plumberNameRE = /^[A-Za-z]([A-Za-z\-\'\s])*[A-Za-z]$/;
const emailRE = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

@Component({
  selector: 'app-plumber-details-mfb',
  templateUrl: './plumber-details-mfb.component.html',
  styleUrls: ['./plumber-details-mfb.component.css']
})
export class PlumberDetailsMfbComponent implements OnInit {

  @Input()
  plumberDetails: PlumberDetailsMfb;
  @Input()
  isReadOnly: boolean;

  plumberNameControl: FormControl = new FormControl();
  plumberPhoneNumberControl: FormControl= new FormControl();
  plumberEmailControl: FormControl= new FormControl();
  plumberLicenseNumberControl: FormControl= new FormControl();

  plumberNameControlMaxLength = 50;

  constructor() {
    this.plumberNameControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.plumberNameControlMaxLength),
      Validators.pattern(plumberNameRE)
    ])]);

    this.plumberPhoneNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(phoneNumberRE)
    ])]);

    this.plumberEmailControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(emailRE)
    ])]);

    this.plumberLicenseNumberControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.pattern(vbaLicenseRE)
    ])]);
  }

  ngOnInit() {
  }

  get invalid(): boolean {
    return (this.plumberNameControl.invalid
        || this.plumberPhoneNumberControl.invalid
        || this.plumberEmailControl.invalid
        || this.plumberLicenseNumberControl.invalid)
  }

  get errorMessage(): string {
    return this.plumberDetails.errorMessage;
  }

  set errorMessage(v: string) {
    this.plumberDetails.errorMessage = v;
  }

  displayErrorMessage(): string {
    this.plumberNameControl.markAsTouched();
    this.plumberPhoneNumberControl.markAsTouched();
    this.plumberEmailControl.markAsTouched();
    this.plumberLicenseNumberControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

      if (this.plumberNameControl.invalid) {
        if (this.plumberNameControl.hasError('maxlength')) {
          errorText += 'Plumber name cannot exceed ' + this.plumberNameControlMaxLength + ' characters' + '<br>';
        }
        if (this.plumberNameControl.hasError('pattern')) {
          errorText += 'Please enter letters, hyphen or apostrophe only in plumber\'s name' + '<br>';
        }
        if (this.plumberNameControl.hasError('required')) {
          errorText += 'Please enter plumber\'s name' + '<br>';
        }
      }

      if (this.plumberPhoneNumberControl.invalid) {
        if (this.plumberPhoneNumberControl.hasError('pattern')) {
          errorText += 'Plumber\'s contact number should have 10 digits' + '<br>';
        }
        if (this.plumberPhoneNumberControl.hasError('required')) {
          errorText += 'Please enter plumber\'s contact number' + '<br>';
        }
      }

      if (this.plumberEmailControl.invalid) {
        if (this.plumberEmailControl.hasError('pattern')) {
          errorText += 'Please enter plumber\'s email address' + '<br>';
        }
        if (this.plumberEmailControl.hasError('required')) {
          errorText += 'Please enter a valid email address' + '<br>';
        }
      }

      if (this.plumberLicenseNumberControl.invalid) {
        if (this.plumberLicenseNumberControl.hasError('required')) {
          errorText += 'Please enter plumber\'s VBA license number' + '<br>';
        }
        if (this.plumberLicenseNumberControl.hasError('pattern')) {
          errorText += 'VBA license number is 6 characters max (less is allowed) and no special or alpha' + '<br>';
        }
      }
    
    this.markValidationControlsAsUntouched();

    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }

  markValidationControlsAsUntouched() {
    this.plumberNameControl.markAsUntouched();
    this.plumberPhoneNumberControl.markAsUntouched();
    this.plumberEmailControl.markAsUntouched();
    this.plumberLicenseNumberControl.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/plumber-details-mfb/plumber-details-mfb.component.ts